import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import ReactPlaceholder from 'react-placeholder';
import { Row, InputPlaceholder, TextareaPlaceholder } from '@contently/toolkit';
import { get } from '../../../utils/shared/api';
import Comment from './comment';
import NewCommentForm from './comment_form';

const CommmentsPlaceholder = () => {
  return (
    <div>
      {[1, 2, 3].map(value => {
        return (
          <ReactPlaceholder
            showLoadingAnimation
            customPlaceholder={<InputPlaceholder wrapperClass="row" withLabel />}
            ready={false}
            key={value}
          >
            <div />
          </ReactPlaceholder>
        );
      })}

      <ReactPlaceholder
        showLoadingAnimation
        customPlaceholder={<TextareaPlaceholder wrapperClass="row" withLabel />}
        ready={false}
      >
        <div />
      </ReactPlaceholder>
    </div>
  );
};

const Comments = props => {
  const { appData } = props;
  const { path } = JSON.parse(appData);
  const [comments, setComments] = useState([]);
  const [isFetching, setIsFetching] = useState(true);

  async function fetchComments() {
    setComments(await get(path));
    setIsFetching(false);
  }

  useEffect(() => {
    fetchComments();
  }, []);

  const addComment = comment => {
    const newComments = [...comments, comment];

    setComments(newComments);
  };

  const form = (
    <Row>
      <NewCommentForm path={path} addComment={addComment} />
    </Row>
  );

  if (isFetching) return <CommmentsPlaceholder />;
  if (!comments.length) return form;

  const renderedComments = comments.map(comment => {
    const { id } = comment;
    return <Comment {...comment} key={id} />;
  });

  return (
    <Fragment>
      <div className="list-container">{renderedComments}</div>
      {form}
    </Fragment>
  );
};

Comments.propTypes = {
  appData: PropTypes.string.isRequired
};

export default Comments;



// WEBPACK FOOTER //
// ./app/javascript/app/components/comments/comments.jsx